/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IIframeViewProps } from './iframe';

/**
 *
 * IFrameView component.
 * @extends {React.PureComponent<IIframeViewProps>}
 */
export class IFrameView extends React.PureComponent<IIframeViewProps> {

    public render(): JSX.Element | null {
        const { Heading, IframeContainer, IFrame, alert, cookieConsentAccepted } = this.props;

        return (
            <Module {...IframeContainer} >
                {alert}
                {cookieConsentAccepted && cookieConsentAccepted ? (
                    <>
                        {Heading}
                        {IFrame}
                    </>) : null}
            </Module>
        );
    }
}
export default IFrameView;
